<template>
  <div class="housing-modify">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">所在楼栋：</span>
          </div>
          <el-input v-model="formData.buildingName" size="small" style="width: 220px" disabled />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">所在楼层：</span>
          </div>
          <el-select v-model="formData.floorCode" placeholder="请选择" size="mini" style="width: 220px">
            <el-option v-for="item in floorList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-input v-model="formData.roomNumber" size="small" style="width: 220px" />
        </div>
      </div>

      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房源面积：</span>
          </div>
          <el-input v-model="formData.roomArea" size="small" style="width: 220px" >
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">装修：</span>
          </div>
          <el-select v-model="formData.fitment" placeholder="请选择" size="mini" style="width: 220px">
            <el-option v-for="item in fitmentList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">房间朝向：</span>
          </div>
          <el-input v-model="formData.roomLocation" size="small" style="width: 220px" />
        </div>
      </div>

      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间用途：</span>
          </div>
          <el-select v-model="formData.type" placeholder="请选择" size="mini" style="width: 220px">
            <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间类型：</span>
          </div>
          <select-with-operation :selectValue="roomTypeCode" style="width: 220px" :optionList="roomTypeList" addTip="添加房间类型" deleteTipInfo="是否确认删除该房间类型？" @addOption="addRoomType" @deleteOption="deleteRoomType" @changeSelectValue="changeRoomType" />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">出租类型：</span>
          </div>
          <el-radio-group v-model="formData.rentType" style="width: 220px" size="small">
            <el-radio-button :label="0">按整房出租</el-radio-button>
            <el-radio-button :label="1">按床位出租</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="form-line" v-if="formData.rentType === 0">
        <div >
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间价格：</span>
          </div>
          <el-input v-model="formData.rentMoney" size="small" style="width: 220px" >
            <template slot="append">元 / 月</template>
          </el-input>
        </div>
        <div></div>
        <div></div>
      </div>

      <div class="form-line" v-if="formData.rentType === 1" style="align-items: flex-start">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">床位数量：</span>
          </div>
          <div style="flex: 1">
            <el-input-number v-model="formData.bedsCount" @input="bedsCountChange" size="small" controls-position="right" :min="1" style="flex: 1;width: 100%"></el-input-number>
            <div class="bed-price-box">
              <div class="bed-price-line" v-for="(item, index) in formData.beds" :key="index">
                <div class="bed-price-item">
                  <el-input v-model="formData.beds[index].bedsNumber" size="small" style="width: 100px" placeholder="床位编号" @input="bedsInfoInput(item, index, 'bedsNumber')">
                    <template slot="prepend"><i class="el-icon-damai-fangjianguanli"></i></template>
                  </el-input>
                </div>
                <div class="bed-price-item">
                  <el-input v-model="formData.beds[index].price" size="small" style="width: 100px" placeholder="床位价格" @input="bedsInfoInput(item, index, 'price')">
                    <template slot="prepend"><i class="el-icon-damai-wuyefeiyongchuzhang"></i></template>
                    <template slot="append">元 / 月</template>
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>

      <div class="form-line" style="height: 120px;">
        <div>
          <div class="textBox" style="line-height: initial;padding: 10px 0 0 0;">
            <span class="line-text">房间图片：</span>
          </div>
          <upload-img-list @getImgList="getRoomImgList" :defaultImg="roomDefaultImgList" />
        </div>
      </div>

      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">房间简介：</span>
          </div>
          <el-input v-model="formData.roomIntroduce" type="textarea" :rows="3"  size="small" style="width: 220px" />
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {api} from '../../api/HousingManagement'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import {pattern} from '../../../utils/regular'
import {bus} from '../../../utils/bus'
import UploadImgList from '../../../components/Input/UploadImgList'
import UploadImgToGetUrl from '../../../components/Input/UploadImgToGetUrl'
import SelectWithOperation from "../../../components/Select/SelectWithOperation";

export default {
  components: {
    SelectWithOperation,
    UploadImgToGetUrl,
    UploadImgList,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'housing-modify',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '房屋管理'
      }],
      mainTitle: '修改房间',
      subheading: '修改房间信息，租赁住户及联系人信息',
      housingManagementPageBuildingTabState: '',
      maxPerFloorArea: '',
      floorList: [],
      floorCode: '',
      fitmentList: [
        {code: '0', name: '精装'},
        {code: '1', name: '简装'},
        {code: '2', name: '毛坯'}
      ],
      typeList: [
        {code: '10', name: '公用'},
        {code: '11', name: '自用'},
        {code: '12', name: '出租'}
      ],
      roomTypeList: [],
      roomDefaultImgList: [],
      roomImageList: [],
      roomBase64List: [],
      roomImageListArr: [],
      roomTypeCode: '',
      formData: {
        buildingCode: '',
        buildingName: '',
        floorCode: '',
        floorName: '',
        roomNumber: '',
        roomArea: '',
        roomType: '',
        type: '12',
        rentType: 0,
        roomLocation: '',
        fitment: '',
        roomIntroduce: '',
        rentMoney: '',
        bedsCount: 1,
        beds: [
          {bedsNumber: '', price: ''}
        ],
      },
      tempType: '',
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.getRoomTypeList()
  },
  methods: {
    toHousingManagement () {
      this.$router.push({
        name: 'housing-management'
      })
    },
    getRoomImgList (imageList, base64List) {
      this.roomImageList = imageList
      this.roomBase64List = base64List
    },
    // 选择房间类型
    changeRoomType (e) {
      this.roomTypeCode = e
    },
    // 添加房间类型弹窗
    wantAddRoomType () {
      this.roomTypeName = ''
      this.addRoomTypeVisible = true
    },
    // 添加房间类型
    addRoomType () {
      if (!this.roomTypeName) {
        nError('请输入房间类型名称')
      }
      this.$axios.post(api.addRoomType, {
        name: this.roomTypeName
      })
        .then(res => {
          this.addRoomTypeVisible = false
          nSuccess('添加成功')
          this.getRoomTypeList()
        })
        .catch(errorHandler('添加失败'))
    },
    // 删除房间类型
    deleteRoomType (option) {
      this.$axios.post(api.deleteRoomType, [option.code])
        .then(res => {
          nSuccess('删除成功')
          this.getRoomTypeList()
        })
        .catch(errorHandler('删除失败'))
    },
    // 获取房间类型列表
    getRoomTypeList () {
      this.$axios.post(api.getRoomTypeList, {})
        .then(res => {
          let data = res.data.data
          this.roomTypeList = data
          this.getRoomInfoByCode()
        })
        .catch(errorHandler('获取房间类型列表失败'))
    },
    getBuildingList () {
      // let accountName = bus.global.accountName
      // this.$axios.post(`${api.getBuildingList}/${accountName}`, {})
      this.$axios.post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.map(v => {
              if (v.code === this.formData.buildingCode) {
                this.floorList = v.floors
                this.formData.buildingName = v.name
              }
            })
          }
        })
        .catch(errorHandler('获取楼栋列表失败'))
    },
    getRoomInfoByCode () {
      this.$axios.get(`${api.getRoomInfoByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.formData = data
            this.tempType = this.formData.type || ''
            if (this.formData.roomPicList) {
              this.roomDefaultImgList = this.formData.roomPicList.split(',')
            } else {
              this.roomDefaultImgList = []
            }
            this.roomTypeList.map(v => {
              if (v.name === this.formData.roomType) {
                this.roomTypeCode = v.code
              }
            })
            if (this.formData.beds.length === 0) {
              this.formData.bedsCount = 1
              this.formData.beds = [
                {bedsNumber: '', price: ''}
              ]
            } else {
              this.formData.bedsCount = this.formData.beds.length
            }
            this.getBuildingList()
          }
        })
        .catch(errorHandler('查询房源信息失败'))
    },
    // 保留两位小数
    changeFormDataNumber () {
      if (this.formData.roomArea) {
        this.formData.roomArea = parseFloat(this.formData.roomArea).toFixed(2)
      }
      if (this.formData.roomRent) {
        this.formData.roomRent = parseFloat(this.formData.roomRent).toFixed(2)
      }
      if (this.formData.officeSeat) {
        this.formData.officeSeat = parseInt(this.formData.officeSeat)
      }
    },

    bedsCountChange (value) {
      this.formData.beds.length = value
      for (let i = 0; i < value; i++) {
        if (!this.formData.beds[i]) {
          let obj = {bedsNumber: '', price: ''}
          this.formData.beds[i] = obj
        }
      }
    },

    bedsInfoInput (item, index, str) {
      this.$forceUpdate()
    },

    // 上传图片
    uploadPictureToGetUrl (base64) {
      return this.$axios.post(api.uploadImg, {
        picData: base64
      })
    },

    async upRoomImageList () {
      let roomImageListArr = []
      for (let k = 0; k < this.roomImageList.length; k++) {
        if (!this.roomImageList[k].name) {
          roomImageListArr.push(this.roomImageList[k].src)
        }
        for (let j = 0; j < this.roomBase64List.length; j++) {
          if (this.roomImageList[k].name && this.roomImageList[k].name.split('.')[0] === this.roomBase64List[j].code) {
            let imgUrl = ''
            await this.uploadPictureToGetUrl(this.roomBase64List[j].personImageStr)
              .then(res => {
                imgUrl = res.data.data
              })
              .catch(errorHandler('图片上传失败'))
            roomImageListArr.push(imgUrl)
          }
        }
      }
      this.roomImageListArr = roomImageListArr
    },

    async confirm () {
      if (!this.formData.floorCode) {
        nError('请选择所在楼层')
        return false
      }
      if (!this.formData.roomNumber) {
        nError('请输入房间号')
        return false
      }
      if (!this.formData.roomArea || (parseFloat(this.formData.roomArea) === 0)) {
        nError('请输入房源面积')
        return false
      }
      if (!this.formData.fitment) {
        nError('请选择装修')
        return false
      }
      if (!this.roomTypeCode) {
        nError('请选择房间类型')
        return false
      }
      if (this.formData.rentType === 0 && !this.formData.rentMoney) {
        nError('请输入房间价格')
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      await this.upRoomImageList()
      this.floorList.map(v => {
        if (v.code === this.formData.floorCode) {
          this.formData.floorName = v.name
        }
      })

      let roomAreaReg = pattern.subsidy
      let roomAreaTest = roomAreaReg.test(this.formData.roomArea)
      if (!roomAreaTest) {
        nError('请输入准确面积且保留两位小数')
        return false
      }
      if (this.roomImageListArr.length > 0) {
        this.formData.roomPicList = this.roomImageListArr.join(',')
      } else {
        this.formData.roomPicList = ''
      }
      this.formData.code = this.currentCode
      this.roomTypeList.map(type => {
        if (type.code === this.roomTypeCode) {
          this.formData.roomType = type.name
        }
      })

      if (this.tempType && this.tempType === this.formData.rentStatus) {
        this.formData.rentStatus = '0'
      }

      this.$axios.post(api.updateRoomInfo, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            loading.close()
            this.toHousingManagement()
          }
        })
        .catch(errorHandler('修改失败'))
        .then(()=> {loading.close()})
    },
    cancel () {
      this.toHousingManagement()
    }
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: middle;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.form-line>div {
  flex: 1;
  margin-right: 20px;
  display: flex;
  justify-content: flex-start;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
  line-height: 32px;
}
.form-btn-box {
  width: 530px;
  margin: 40px auto 0;
  padding: 0 124px;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.housing-modify {
  .bed-price-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
    .bed-price-line {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .bed-price-item {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .el-input__inner {
          padding: 0 5px;
        }
      }
      .bed-price-item:first-child {
        margin-right: 10px;
      }
    }
    .bed-price-line:last-child {
      border: 0;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/HousingManagement/HousingModify.vue